export const CREATE_COMMUNITY_PATH = '/create-community';
